import { monitoringActionTypes } from 'common/ducks/actionTypes';

export const setGraphSelection = (center, event = null) => ({
  type: monitoringActionTypes.setGraphSelection.requested,
  payload: { center, event },
});
